import { FilterMap } from "../../../types/main";

type Props = {
  organizationId: number,
}

const makeFilterMap = ({ organizationId }:Props): FilterMap[] => [
  {
    key: 'organization_id',
    label: "All",
    value: organizationId,
    required: true,
  },
  {
    key: 'in_org',
    label: 'Members',
    value: 1,
  },
  {
    key: 'not_in_org',
    label: 'Non-members',
    value: 1,
  },
];

export default makeFilterMap;
